/* @ngInject */
function templateService ($rootScope, Utils, CONSTANTS, ConnectorWebService) {
  return {
    permissionToUse,
    getTemplateById,
    getTemplateDetailsById,
    getDefaultThumbnail,
    moveTemplate,
    changeTemplateOrder,
    searchByName,
    unavailableArtsByTemplateId,
    getTemplateActivity,
    getTemplateDetailsForPreview,
    getTemplateTags,
    moveMultipleTemplates
  }

  function moveMultipleTemplates (ids, toId) {
    const url = CONSTANTS.URL_TEMPLATES_MOVE_MULTIPLE

    return ConnectorWebService.put(url, { templateIds: ids, artCollectionId: toId })
  }

  function permissionToUse (template) {
    return { download: _canDownload(template), customizes: _canCustomizes(template) }
  }

  function getTemplateById (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID, [id])
    return ConnectorWebService.get(url)
  }

  function getTemplateDetailsById (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID_DETAILS, [id])
    return ConnectorWebService.get(url)
  }

  function _canDownload (template) {
    return _customization(template, true)
  }

  function _canCustomizes (template) {
    return _customization(template, false)
  }

  function _customization (template, canDownload) {
    const download = template.customizationLevel === 'ONLY_DOWNLOAD'
    const userAdmin = $rootScope.isUserSysAdminAdmin()

    if (canDownload) {
      return (download && !userAdmin) || !template.isCustomizable
    }

    return (!download || userAdmin) && template.isCustomizable
  }

  function getDefaultThumbnail (extension) {
    const baseUrl = '/assets/icons/files/'
    let url

    switch (extension) {
      case 'ai':
        url = baseUrl + 'ai.svg'
        break
      case 'docx':
      case 'doc':
        url = baseUrl + 'doc.svg'
        break
      case 'in':
        url = baseUrl + 'in.svg'
        break
      case 'ttf':
        url = baseUrl + 'font.svg'
        break
      case 'ps':
        url = baseUrl + 'ps.svg'
        break
      case 'zip':
        url = baseUrl + 'zip.svg'
        break
      case 'xlsx':
      case 'xls':
        url = baseUrl + 'excel.svg'
        break
      case 'pptx':
      case 'ppt':
        url = baseUrl + 'ppt.svg'
        break
      case 'aac':
      case 'mp3':
      case 'ogg':
      case 'wma':
      case 'alac':
      case 'aiff':
      case 'pcm':
      case 'wav':
        url = baseUrl + 'audio.svg'
        break
      case 'wmv':
      case 'avi':
      case 'flv':
      case 'mov':
      case 'rmvb':
      case 'mkv':
      case 'mp4':
        url = baseUrl + 'video.svg'
        break
      default:
        url = baseUrl + 'img.svg'
    }

    return url
  }

  function moveTemplate (id, toId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID_MOVE, [id])

    return ConnectorWebService.put(url, { artCollectionId: toId })
  }

  function changeTemplateOrder (id, order) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID_ORDER, [id])

    return ConnectorWebService.put(url, { order })
  }

  function searchByName (top, skip, search, isAnalytics) {
    let url = CONSTANTS.URL_TEMPLATES_SEARCH_BY_NAME

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { term: search })
    }

    if (isAnalytics) {
      url = Utils.fnAddQueryToUrl(url, { isAnalytics })
    }

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    return ConnectorWebService.get(url)
  }

  function unavailableArtsByTemplateId (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID_UNAVAILABLE_ARTS, [id])

    return ConnectorWebService.put(url)
  }

  function getTemplateActivity (id, top, skip) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID_ACTIVITIES, [id])

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    return ConnectorWebService.get(url)
  }

  function getTemplateDetailsForPreview (templateId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID_DETAILS_PREVIEW, [templateId])

    return ConnectorWebService.get(url)
  }

  function getTemplateTags (templateId) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_ID_TAGS, [templateId])

    return ConnectorWebService.get(url)
  }
}

export { templateService }
